var React = require('react');

function BedEmpty (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M208,128H112a16,16,0,0,0-16,16V288H224V144A16,16,0,0,0,208,128Zm320,0H272a16,16,0,0,0-16,16V288H640V240A112,112,0,0,0,528,128Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M640,288V432a16,16,0,0,1-16,16H592a16,16,0,0,1-16-16V384H64v48a16,16,0,0,1-16,16H16A16,16,0,0,1,0,432V80A16,16,0,0,1,16,64H48A16,16,0,0,1,64,80V288Z","className":"fa-primary","key":2})]);
}

BedEmpty.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = BedEmpty;

BedEmpty.default = BedEmpty;
